import {
    ADD_MATERIAL,
    ADD_MATERIAL_IMPORT,
    GET_MATERIAL,
    GET_MATERIAL_UNITS_DATA,
    GET_MATERIALS, GET_MATERIALS_OPTIONS,
    GET_SUPPLIER_OPTIONS,
    GET_WAREHOUSE_OPTIONS,
    MATERIAL_ERROR,
    MATERIAL_UNITS_DATA_ERROR,
    REMOVE_DELETE_MATERIAL,
    REMOVE_UPDATE_MATERIAL,
    SET_DELETE_MATERIAL_ID,
    SET_UPDATE_MATERILA_ID,
    GET_MATERIAL_TRANSACTIONS,
    CLEAR_ERRORS,
    CLEAR_MATERIAL_TRANSACTIONS,
    GET_MATERIAL_IMPORTS,
    GET_MATERIAL_SPENDS,
    GET_SUPPLIERS_MATERIALS_TRANSACTIONS,
    SET_LOADING,
    UNSET_LOADING, GET_SUPPLIER_MATERIALS_TRANSACTIONS
} from '../actions/types';

const initialState = {
    suppliers: [],
    material: {},
    material_options: [],
    loading: true,
    numberOfPages: 1,
    total_materials: null,
    error: null,
};

// eslint-disable-next-line
export default function (state = initialState, action) {
    const {type, payload} = action;

    switch (type) {
        case SET_LOADING:
            return {
                ...state,
                loading: true,
            }
        case UNSET_LOADING:
            return {
                ...state,
                loading: false,
            }
        case GET_MATERIALS_OPTIONS:

            return {
                ...state,
                material_options: payload.data,
                loading: false,
            };

        case CLEAR_MATERIAL_TRANSACTIONS:

            return {
                ...state,
                material_options: [],
                loading: false,
            };

        case GET_SUPPLIERS_MATERIALS_TRANSACTIONS:
            const {dates, suppliers} = payload;
            return {
                ...state,
                dates: dates,
                suppliers: [...suppliers.data],
                numberOfPages: suppliers.last_page,
                current_page: suppliers.current_page,
                suppliers_data: payload,
                error: null,
                loading: false,
            };

        case GET_SUPPLIER_MATERIALS_TRANSACTIONS:

            return {
                ...state,
                suppliers: state.suppliers.map((item) => item.id == payload.id ? payload : item),
                loading: false,
            };

        case CLEAR_ERRORS:
            return {
                ...state,
                error: null,
            };

        case ADD_MATERIAL:
            return {
                ...state,
                materials: [payload],
                error: null,
                loading: false,
            };

        case MATERIAL_ERROR:
            return {
                ...state,
                error: payload,
                loading: false,
            };

        default:
            return state;
    }
}


